import { jsx as r, Fragment as c } from "react/jsx-runtime";
import { SectionedMenu as w } from "./index.es5573.js";
import { Combobox as u } from "@headlessui/react";
import { noop as m } from "lodash/fp";
import { useCallback as f } from "react";
import t from "./index.es5574.js";
import D from "classnames";
import { onKeyDownEnterAndSpace as C } from "./index.es526.js";
import { BasicMenuItem as E } from "./index.es83.js";
import { MultilineItem as N } from "./index.es85.js";
import { MultilineDropdownMenu as K } from "./index.es79.js";
const R = ({
  items: e,
  noResultsItem: v,
  menuType: i,
  activeLoadingSkeleton: l,
  highLightText: d,
  onNoResultClick: b = m,
  onMenuItemClick: a = m
}) => {
  const s = f(
    (o) => {
      l || a(o);
    },
    [l, a]
  ), h = f(
    (o, n) => {
      C(o, () => s(n));
    },
    [s]
  );
  if (e === void 0 || e.length === 0)
    return /* @__PURE__ */ r(
      u.Option,
      {
        value: null,
        as: "div",
        className: D(t.option, t.noResult),
        onClick: b,
        "data-testid": "no-results-option",
        children: v
      },
      "no-results"
    );
  const p = (o) => /* @__PURE__ */ r(
    w,
    {
      ...o,
      searchTerm: d,
      onMenuItemClick: (n) => {
        a(n);
      },
      items: e.map(({ sectionTitleProps: n, items: M }) => ({
        ...n,
        Menu: /* @__PURE__ */ r(K, { items: M })
      }))
    }
  );
  return i === "sectioned" ? /* @__PURE__ */ r(p, { isShowMoreEnabled: !1 }) : i === "sectioned-with-view-more" ? /* @__PURE__ */ r(p, { isShowMoreEnabled: !0 }) : i === "single-select" ? /* @__PURE__ */ r(c, { children: e.map((o, n) => /* @__PURE__ */ r(
    u.Option,
    {
      value: o.value,
      as: "div",
      className: t.option,
      disabled: o.isDisabled,
      onClick: () => s(o),
      children: /* @__PURE__ */ r(
        E,
        {
          ...o,
          hasDivider: n !== e.length - 1,
          isLoading: l
        }
      )
    },
    o.value
  )) }) : i === "multiline" ? /* @__PURE__ */ r(c, { children: e.map((o) => /* @__PURE__ */ r(
    u.Option,
    {
      value: o.value,
      as: "div",
      className: t.option,
      disabled: o.isDisabled,
      onClick: () => s(o),
      onKeyDown: (n) => h(n, o),
      children: /* @__PURE__ */ r(
        N,
        {
          highLightText: d,
          ...o,
          isLoading: l
        }
      )
    },
    o.value
  )) }) : null;
};
export {
  R as AutoCompleteMenu
};
//# sourceMappingURL=index.es2473.js.map
